var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublicSaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43 10.5862V21.6207C43 22.1694 42.782 22.6956 42.394 23.0836C42.006 23.4716 41.4798 23.6896 40.931 23.6896C40.3823 23.6896 39.8561 23.4716 39.4681 23.0836C39.0801 22.6956 38.8621 22.1694 38.8621 21.6207V15.5862L25.8431 28.6069C25.6509 28.7998 25.4225 28.9528 25.171 29.0572C24.9195 29.1616 24.6499 29.2154 24.3776 29.2154C24.1053 29.2154 23.8357 29.1616 23.5842 29.0572C23.3327 28.9528 23.1043 28.7998 22.9121 28.6069L17.4828 23.1724L6.53276 34.1189C6.14408 34.5076 5.61692 34.726 5.06724 34.726C4.51757 34.726 3.99041 34.5076 3.60173 34.1189C3.21305 33.7303 2.99469 33.2031 2.99469 32.6534C2.99469 32.1037 3.21305 31.5766 3.60173 31.1879L16.0155 18.7741C16.2077 18.5812 16.4361 18.4282 16.6876 18.3238C16.9391 18.2193 17.2087 18.1656 17.481 18.1656C17.7533 18.1656 18.023 18.2193 18.2745 18.3238C18.5259 18.4282 18.7543 18.5812 18.9466 18.7741L24.3793 24.2069L35.931 12.6551H29.8966C29.3478 12.6551 28.8216 12.4372 28.4336 12.0492C28.0456 11.6612 27.8276 11.1349 27.8276 10.5862C27.8276 10.0375 28.0456 9.5112 28.4336 9.1232C28.8216 8.73519 29.3478 8.51721 29.8966 8.51721H40.931C41.4798 8.51721 42.006 8.73519 42.394 9.1232C42.782 9.5112 43 10.0375 43 10.5862Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublicSaleIcon);
export default __webpack_public_path__ + "static/media/publicSaleIcon.021d75b43735ed3ae81b6a9bb7da0a70.svg";
export { ForwardRef as ReactComponent };